import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';

// --- PrimeNG ---
import { MessageService } from 'primeng/api';

// --- Facades ---
import { CartFacade } from '@facades/cart.facade';

// --- Utils ---
import { isObjectChanged } from '@utils/diff.util';

// --- Interfaces ---
import type { ICartLocalStorage } from '@interfaces/cart';
import type { IProduct } from '@interfaces/product';
import type { IProductCart } from '@interfaces/productCart';

@Component({
	selector: 'app-cart-overlay-panel',
	templateUrl: './cart-overlay-panel.component.html',
	styleUrls: ['./cart-overlay-panel.component.scss'],
})
export class CartOverlayPanelComponent implements OnInit, OnDestroy {
	parameters = JSON.parse(localStorage.getItem('parameters') as string);
	objectFit = 'cover';
	private subs = new SubSink();

	products: IProductCart[] = [];
	currentProducts: IProductCart[] = [];

	@Output() clickOpenCartEvent = new EventEmitter<void>();
	@Output() emptyCartEvent = new EventEmitter<void>();

	constructor(
		private _router: Router,
		private _messageService: MessageService,
		public cartFacade: CartFacade
	) {
		this.objectFit = this.parameters?.allowResizeProductImages
			? 'contain'
			: 'cover';
	}

	ngOnInit(): void {
		this.products = this.cartFacade.getCartCache();
		this.currentProducts = this.products;
	}

	get storedCart() {
		return JSON.parse(localStorage.getItem('cart')!) as ICartLocalStorage;
	}

	saveCart() {
		const changed = isObjectChanged(
			this.currentProducts,
			this.storedCart.products
		);
		if (!changed) return;

		this.subs.add(
			this.cartFacade.saveCart(this.storedCart.products).subscribe({
				next: items => {
					const cart = { ...this.storedCart, products: items.result };
					localStorage.setItem('cart', JSON.stringify(cart));
				},
				error: () => {
					this._messageService.add({
						severity: 'error',
						summary: 'Houve um problema!',
						detail: 'Não foi possível atualizar o carrinho.',
					});
				},
			})
		);
	}

	getQtd(qtd: number, product: IProduct, unitPrice: number) {
		product.prices = [{ price: unitPrice }];
		this.cartFacade.changeQtd(product, qtd);
	}

	trackByProduct(index: number, item: IProductCart) {
		return item.productId;
	}

	openCart() {
		this.clickOpenCartEvent.emit();
		return this._router.navigate(['account', 'cart']);
	}

	removeProduct(id: number) {
		const products = this.cartFacade.removeProduct(id);
		this.products = products || [];

		if (this.products.length <= 0) this.emptyCartEvent.emit();
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
		setTimeout(() => this.saveCart(), 800);
	}
}
